module.exports = require("decode-html");